export enum TABS_HOME {
  PRODUCTS = 'products',
  REPAIRS = 'repairs',
}
